module.exports = __webpack_public_path__ + "static/img/reference pics_hsuehshan tunnel1.57e73244.jpg";